import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-salary-list',
  templateUrl: './salary-list.component.html',
  styleUrls: ['./salary-list.component.scss']
})
export class SalaryListComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
